import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import useFormatById from "src/hooks/utils/useFormatById";
import actions from "src/store/common/actions";

const OpenFileWithOid = () => {
  const f = useFormatById();
  const dispatch = useDispatch();
  const params = useParams();

  const requestDocTitles = useSelector(
    (state) => state.common.requestDocTitles
  );

  const downloadDoc = (hasLoading) => {
    if (requestDocTitles?.length) {
      const oid = requestDocTitles
        ?.flatMap((o) => o.docGet)
        .find((o) => o.fileName === params.documentName)?.docTypeKey;

      console.log(oid);

      dispatch(
        actions.getDownloadDocument({
          oid: oid,
          hasLoading,
        })
      );
    }
  };

  useEffect(() => {
    dispatch(actions.getDocTitles(1));
  }, []);

  useEffect(() => {
    const isMobile = /Mobi|Android/i.test(navigator.userAgent);
    if (isMobile) {
      dispatch(actions.setDownloadDocumentLoading(false));
    } else {
      downloadDoc();
    }
  }, [requestDocTitles]);

  const loading = useSelector((state) => state.common.downloadDocumentLoading);

  return (
    <>
      {loading ? (
        <div
          class="imedil-loader"
          style={{ position: "relative", marginTop: "160px" }}
        >
          <div class="circle">
            <div class="wave">
              <svg
                width="59"
                height="76"
                marginBottom="0"
                viewBox="0 0 59 76"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.56 76V0.399995H21.944V59.044H58.016V76H0.56Z"
                  fill="white"
                ></path>
              </svg>
            </div>
          </div>
        </div>
      ) : (
        <h1
          className="mx-auto my-5 pt-5 text-decoration-underline"
          style={{ color: "#163164" }}
          onClick={() => downloadDoc(false)}
        >
          {f("common.donwloadFile")}
        </h1>
      )}
    </>
  );
};

export default OpenFileWithOid;
